import React, { Component } from 'react'
import Img from 'gatsby-image'
import Slider from 'react-slick'

import SlideshowArrowRight from '../svgs/slideshow-arrow-right'
import SlideshowArrowLeft from '../svgs/slideshow-arrow-left'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import './style.sass'

import cursorCrosshair from '../../images/cursor-crosshair.png'
import cursorMinimize from '../../images/cursor-minimize.png'

export default class Slideshow extends Component {
  state = {
    isFullscreen: false,
    currentSlide: 0,
  }

  toggleFullscreen = () => {
    this.setState(
      { isFullscreen: !this.state.isFullscreen },
      () =>
        (document.body.style.overflow = this.state.isFullscreen
          ? 'hidden'
          : 'auto')
    )
  }

  handleSlideChange = currentSlide => {
    this.setState({ currentSlide })
  }

  render() {
    const settings = {
      autoplay: false,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      nextArrow: <SlideshowArrowRight />,
      prevArrow: <SlideshowArrowLeft />,
      afterChange: this.handleSlideChange,
      initialSlide: this.state.currentSlide,
    }

    if (!this.state.isFullscreen) {
      return (
        <div
          style={{
            position: 'relative',
            cursor: `url(${cursorCrosshair}) 25 15, auto`,
          }}
        >
          <div className="Slideshow">
            <Slider {...settings}>
              {this.props.images.map((slide, index) => (
                <div key={index} onClick={this.toggleFullscreen}>
                  <Img
                    imgStyle={{
                      height: '400px',
                      width: 'auto',
                      left: '50%',
                      transform: 'translateX(-50%)',
                    }}
                    fluid={slide.immagine.fluid}
                    style={{
                      height: '400px',
                    }}
                  />
                  <div className="Slideshow__Caption text-bold mt-1">
                    {slide.didascalia}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )
    }

    return (
      <div
        className="Slideshow--fullscreen"
        style={{ cursor: `url(${cursorMinimize}) 25 25, auto` }}
      >
        <Slider {...settings}>
          {this.props.images.map((slide, index) => (
            <div
              className="Slideshow__ImageContainer"
              key={index}
              onClick={this.toggleFullscreen}
            >
              <Img
                imgStyle={{
                  height: '100%',
                  width: 'auto',
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}
                fluid={slide.immagine.fluid}
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bottom: '4rem',
                  left: 0,
                }}
              />
              <div className="Slideshow__Caption text-bold mt-1">
                {slide.didascalia}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/slideshow/index.js